export default {
  SET_LOCATIONS_GRID(state, { locations, pagesCount, totalCountData }) {
    state.locations = locations;
    state.pagesCount = pagesCount;
    state.totalCountData = totalCountData;
  },
  SET_LOCATIONS(state, locations) {
    state.locations = locations
  },
  SET_LOCATION(state, location) {
    state.location = location
  },
  ADD_LOCATION(state, location) {
    state.locations.push(location)
  },
  UPDATE_LOCATION(state, location) {
    const index = state.locations.findIndex((i) => i.id === location.id)
    state.locations.splice(index, 1, location)
  },
  DELETE_LOCATION(state, id) {
    const index = state.locations.findIndex((i) => i.id === id)
    state.locations.splice(index, 1)
  }
}
